var path = '/app/pages/account/settings/profile/account.settings.profile.html';
var html = "<div class=\"p-0 p-md-4 bg-white rounded box-shadow-light\"> <div class=\"p-3 py-5 p-md-5\"> <div class=row> <div class=col> <h4 class=\"font-weight-bold mb-4\">{{ ctrl.formTitle }}</h4> <div uib-alert ng-if=ctrl.alerts.local.msg ng-class=\"'p-4 my-4 alert-' + (ctrl.alerts.local.type || 'info')\">{{ ctrl.alerts.local.msg }}</div> <dynamic-form ng-if=ctrl.formTemplate template=ctrl.formTemplate ng-model=ctrl.formTemplate.model></dynamic-form> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/settings/profile/account.settings.profile.html
// module id = 1115
// module chunks = 0